import { type fabric } from 'fabric';
import type Table from '../objects/Table';
import ControlBase from '../fabric/ControlBase';
import { renderAddControl } from './controlRendering';

const SIZE = 22;
const OFFSET = 27;

class TableVectorAddControl extends ControlBase {
  // Name of the action the control is used for.
  actionName: string;
  // Whether this control lies on a row or column
  isRow: boolean;

  constructor(isRow = true) {
    super({});
    this.isRow = isRow;
    this.actionName = `Add ${isRow ? 'row' : 'column'}`;
    this.x = isRow ? 0 : 0.5;
    this.y = isRow ? 0.5 : 0;
    this.offsetX = isRow ? 0 : OFFSET;
    this.offsetY = isRow ? OFFSET : 0;
    this.sizeX = this.touchSizeX = this.sizeY = this.touchSizeY = SIZE;
    this.cursorStyle = 'pointer';
  }

  getMouseUpHandler(
    eventData: MouseEvent,
    fabricObject: fabric.Object,
    control: fabric.Control
  ): fabric.ControlMouseEventHandler {
    return (eventData, transformData) => {
      // Gathering more information on Sentry: https://aha-labs-inc.sentry.io/issues/6243232495/?project=139823&query=is%3Aunresolved%20assigned%3A%23whiteboards&referrer=issue-stream&sort=new&statsPeriod=14d&stream_index=6
      // Trying to determine if we should just return null in this case.
      if (!transformData) {
        console.error('Transform data is null', {
          eventData,
          fabricObject,
          control,
        });
      }

      const object = transformData.target as Table;
      object.addVectorToEnd(this.isRow);
      object.canvas.controller.undoManager.completeUndoGroup();
      return true;
    };
  }

  render(ctx, left, top, styleOverride, fabricObject) {
    renderAddControl.call(
      this,
      ctx,
      left,
      top,
      styleOverride,
      fabricObject,
      SIZE
    );
  }
}
export default TableVectorAddControl;
